import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import $ from "jquery";
import TtsApiSettings from "./TtsApiSettings";
import TtsTestTab from "./TtsTestTab";
import TtsReportTab from "./reports/TtsReportTab";
import CustomPronunciationTabs from "./CustomPronunciationTabs";

class TtsLeftPanel extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = ["/api-keys"];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/cloud-tts/";
      var path1 = window.origin + "/platform/cloud-tts";
      if (
        currentPath == path ||
        currentPath == path1 ||
        projectSettingsPathExist
      ) {
        $("#left-panel-menu-projectSettings").addClass("activemenu");
      } else if (currentPath.includes("/test")) {
        $("#left-panel-menu-test").addClass("activemenu");
      } else if (currentPath.includes("/reports")) {
        $("#left-panel-menu-cloud-tts-reports").addClass("activemenu");
      } else if (currentPath.includes("/custom-pronunciation")) {
        $("#left-panel-menu-cloud-tts-custom-pronunciation").addClass(
          "activemenu"
        );
      }
      $(
        "#left-panel-menu-projectSettings,#left-panel-menu-test,#left-panel-menu-cloud-tts-reports,#left-panel-menu-cloud-tts-custom-pronunciation"
      ).on("click", function () {
        $(
          "#left-panel-menu-projectSettings,#left-panel-menu-test,#left-panel-menu-cloud-tts-reports,#left-panel-menu-cloud-tts-custom-pronunciation"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");
      });
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link
            rel="stylesheet"
            href="./plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div
              className="left-menu"
              style={{ marginTop: "0px", position: "absolute" }}
            >
              <ul id="floatMenu">
                <Link to="/cloud-tts">
                  <li id="left-panel-menu-projectSettings" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>API Settings</span>
                  </li>
                </Link>
                <Link to="/cloud-tts/custom-pronunciation">
                  <li
                    id="left-panel-menu-cloud-tts-custom-pronunciation"
                    className="tabs"
                  >
                    <i className="fa flaticon-ui" />
                    <span>Custom Pronunciation</span>
                  </li>
                </Link>
                <Link to="/cloud-tts/test-and-deploy">
                  <li id="left-panel-menu-test" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Test & Deploy</span>
                  </li>
                </Link>
                <Link to="/cloud-tts/reports">
                  <li id="left-panel-menu-cloud-tts-reports" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Report</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-tts/reports" component={TtsReportTab}></Route>
            <Route
              path="/cloud-tts/custom-pronunciation"
              component={CustomPronunciationTabs}
            ></Route>
            <Route
              path="/cloud-tts/test-and-deploy"
              component={TtsTestTab}
            ></Route>
            <Route path="/cloud-tts" component={TtsApiSettings}></Route>
          </Switch>
        </div>
      </Router>
    );
  }
}
export default TtsLeftPanel;



// WEBPACK FOOTER //
// ./src/ttsUi/TtsLeftPanel.js